import type { ReactNode } from 'react';
import { HelpLabel } from './Help';
import { Dash, signClass } from './Val';
import { formatDecimal } from '../lib/decimal';

export function CardHead({ title, hint, children }: { title: string; hint?: ReactNode; children?: ReactNode }) {
  return (
    <div className="card-head">
      <h2>{title}</h2>
      {hint ? <span className="muted small">{hint}</span> : null}
      {children}
    </div>
  );
}

/** A KPI tile: label + help icon, big value (or "—" + reason), small caption. */
export function Kpi({
  helpKey,
  label,
  value,
  reason,
  unit,
  caption,
  tone,
  compact,
  sign,
  dp = 2,
}: {
  helpKey: string;
  label: string;
  value: string | null | undefined;
  reason?: string | null;
  unit?: string | null;
  caption?: ReactNode;
  tone?: 'warn' | 'result';
  compact?: boolean;
  sign?: boolean;
  /** Fixed decimals; null = as many as needed. */
  dp?: number | null;
}) {
  const cls = tone === 'warn' ? 'warn' : tone === 'result' ? signClass(value) : '';
  return (
    <div className={`card kpi${compact ? ' compact' : ''}`}>
      <HelpLabel helpKey={helpKey} label={label.toLowerCase()}>
        {label}
      </HelpLabel>
      <div className={`value mono ${cls}`}>
        {value === null || value === undefined ? <Dash reason={reason} /> : formatDecimal(value, dp === null ? { sign } : { dp, sign })}
        {value !== null && value !== undefined && unit ? <span className="unit"> {unit}</span> : null}
      </div>
      {caption ? <div className="muted small">{caption}</div> : null}
    </div>
  );
}
